import React from "react";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import { Footer } from "~/components/ui/footer";
import { Header } from "~/components/ui/header";

export const Route = createFileRoute("/blog")({
  component: BlogLayout,
});

function BlogLayout() {
  return (
    <div className="flex min-h-screen flex-col justify-between overflow-hidden bg-gray-50">
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
}
